const LabelComponent = {
    templateUrl: '/formViewer/component/label/label.tpl.html',
    controller: 'labelController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<'
    }
};

angular.module('umCore')
    .component('uiLabel', LabelComponent);
